import { type GriffelStyle, makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

const CELL_SIZE = px(28);

const buttonStyles: GriffelStyle = {
    maxWidth: px(28),
    minWidth: px(28),
    aspectRatio: '1 / 1',

    '& svg': {
        fontSize: px(14),
    },
};

export const useStyles = makeStyles({
    root: {
        position: 'relative',
        userSelect: 'none',
        margin: tokens.spacingHorizontalSNudge,
    },

    months: {},
    month: {},

    caption_label: {
        display: 'flex',
        alignItems: 'center',
        paddingInline: tokens.spacingHorizontalS,
        minHeight: '100%',
        maxHeight: '100%',
        fontWeight: tokens.fontWeightMedium,
        fontSize: tokens.fontSizeBase300,
        lineHeight: px(28),
    },

    nav: {
        position: 'absolute',
        display: 'flex',
        right: px(0),
        width: 'max-content',
    },
    button: {},
    button_next: buttonStyles,
    button_previous: buttonStyles,

    month_grid: {
        borderCollapse: 'collapse',
        '& *': {
            fontSize: tokens.fontSizeBase200,
        },
    },

    weekdays: {
        textAlign: 'center',
    },
    weekday: {
        fontWeight: tokens.fontWeightRegular,
    },

    weeks: {},
    week: {},
    day: {
        padding: px(0),
        margin: px(0),
        textAlign: 'center',
        '&:first-child[aria-selected]': {
            borderStartStartRadius: `${tokens.borderRadiusMedium} !important`,
            borderEndStartRadius: `${tokens.borderRadiusMedium} !important`,
        },
        '&:last-child[aria-selected]': {
            borderStartEndRadius: `${tokens.borderRadiusMedium} !important`,
            borderEndEndRadius: `${tokens.borderRadiusMedium} !important`,
        },
    },

    day_button: {
        position: 'relative',
        padding: px(0),
        margin: px(0),
        outline: 'none',
        border: 'none',
        aspectRatio: '1 / 1',
        width: CELL_SIZE,
        backgroundColor: tokens.colorTransparentBackground,
        cursor: 'pointer',
        isolation: 'isolate',
        '&:hover': {
            backgroundColor: tokens.colorBrandBackground2Hover,
            borderRadius: tokens.borderRadiusMedium,
        },
        '&:active': {
            backgroundColor: tokens.colorBrandBackground2Pressed,
            borderRadius: tokens.borderRadiusMedium,
        },
        '&:active::before': {
            zIndex: -1,
            content: '""',
            position: 'absolute',
            inset: 0,
            margin: tokens.spacingVerticalXXS,
            borderRadius: tokens.borderRadiusMedium,
            border: [tokens.strokeWidthThin, 'solid', tokens.colorBrandBackground].join(' '),
        },
    },
    selected: {
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: tokens.colorBrandBackground2,
    },
    range_start: {
        borderRadius: `${px(0)} !important`,
        borderStartStartRadius: `${tokens.borderRadiusMedium} !important`,
        borderEndStartRadius: `${tokens.borderRadiusMedium} !important`,
    },
    range_end: {
        borderRadius: `${px(0)} !important`,
        borderStartEndRadius: `${tokens.borderRadiusMedium} !important`,
        borderEndEndRadius: `${tokens.borderRadiusMedium} !important`,
    },
    range_middle: {
        borderRadius: `${px(0)} !important`,
    },
    today: {
        '& button': {
            position: 'relative',
            fontWeight: tokens.fontWeightSemibold,
            color: `${tokens.colorNeutralBackground1} !important`,

            '&::before': {
                zIndex: -1,
                content: '""',
                position: 'absolute',
                inset: 0,
                borderRadius: '50% !important',
                margin: `${tokens.spacingVerticalXS} !important`,
                backgroundColor: tokens.colorBrandBackground,
            },
        },
    },

    outside: {
        opacity: 0.4,
    },
    disabled: {
        opacity: `${0.2} !important`,
        pointerEvents: 'none',

        '& *': {
            color: tokens.colorNeutralForeground1,
        },
    },
    hidden: {
        visibility: 'hidden',
        pointerEvents: 'none',
    },
});
